import { api } from 'api/api';
import { AccountContext } from 'components/AccountContext';
import { userIsSubscriber } from 'components/Utils/theme';
import { useTelemedicina } from 'context/TelemedicinaContext';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const useModelHorarios = () => {
  const { medicoSelecionado, agendamento, setAgendamento } = useTelemedicina();
  const [loading, setLoading] = useState(true);
  const [agendas, setAgendas] = useState([]);
  const navigate = useNavigate();
  const { user, toastInadimplente } = useContext(AccountContext);
  const assinante = userIsSubscriber(user);
  useEffect(() => {
    const fetchPosts = async () => {
      const procedimentoEspeciadadeSelecionada = medicoSelecionado.horarios
      .flatMap(h => h.procedimentos)
      .find(p => p.ambulatorio_tipo_consulta_id === medicoSelecionado?.especialidadeId);

      const procedimentoId = procedimentoEspeciadadeSelecionada ? procedimentoEspeciadadeSelecionada.id : medicoSelecionado.horarios[0].procedimentos[0].id;

      const url = `${ENDPOINT}/schedule/getAvailabilitySpecialist/${medicoSelecionado.medico.medico}/${procedimentoId}/${user.id_cliente_deovita}/${assinante}/${user?.allowsTelemedicina?.paga_telemedicina ? user.allowsTelemedicina.paga_telemedicina : false}/${
        user.id_contrato
      }/${medicoSelecionado?.especialidadeId}`;
      const response = await api(url, {
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        method: 'GET',
      });
      const postsData = await response.json();
      setAgendas(postsData);
      setLoading(false);
    };
    fetchPosts();
  }, []);
  useEffect(() => {
    setAgendamento((prev) => ({
      ...prev,
      procedimento_id: medicoSelecionado.horarios[0].procedimentos[0].id,
      especialidade_id: medicoSelecionado?.dados?.ambulatorio_tipo_consulta_id,
    }));
  }, [medicoSelecionado.horarios[0].procedimentos[0].id]);

  let data_parcela = '';
  if (user.qntdeParcelas?.countParcelas > 0) {
    data_parcela = user?.qntdeParcelas?.datasParcelas !== null ? new Date(user?.qntdeParcelas?.datasParcelas[0]) : null;
    if (data_parcela !== null) {
      const dia = user?.qntdeParcelas?.forma_pagamento === 13 ? 60 : 0;
      data_parcela.setDate(data_parcela?.getDate() + dia);
    }
  }
  const dataAtual = new Date();
  const clientePendente = user?.loggedIn && user?.qntdeParcelas?.countParcelas && user?.qntdeParcelas?.countParcelas > 0 && dataAtual >= data_parcela;

  useEffect(() => {
    if (!clientePendente) {
      toastInadimplente(user.id_forma_pagamento, user.qntdeParcelas);
    }
  }, [assinante, clientePendente]);

  return {
    medicoSelecionado,
    loading,
    navigate,
    agendas,
    setAgendamento,
  };
};

export default useModelHorarios;
